module.exports = __webpack_public_path__ + "hero-next-768-65ce779f75885fc5ec81e3fca15b4d1e.bundle.webp";